export default __webpack_public_path__ + "static/media/left-arrow-hover.bcd76570.svg";